module.exports = __webpack_public_path__ + "static/media/BQ-5.fc17341f.jpg";